import { render, staticRenderFns } from "./PermissionsGroupTablePage.vue?vue&type=template&id=4747594d&scoped=true"
import script from "./PermissionsGroupTablePage.vue?vue&type=script&lang=js"
export * from "./PermissionsGroupTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4747594d",
  null
  
)

export default component.exports